import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HttpClientModule } from '@angular/common/http';
import { NuevoClienteComponent } from './nuevo-cliente/nuevo-cliente.component';
import { NuevaCuentaComponent } from './nueva-cuenta/nueva-cuenta.component';
import { ModalesComponent } from './modales/modales.component';
import { DetallesCuentaComponent } from './detalles-cuenta/detalles-cuenta.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, CurrencyPipe } from '@angular/common';


@NgModule({
  declarations: [
    AppComponent,
    ModalesComponent,
    DetallesCuentaComponent,
    NuevoClienteComponent,
    NuevaCuentaComponent
  ],
  entryComponents: [],
  imports: [
    BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule, 
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    CurrencyPipe,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
